import { GetterTree } from "vuex";
import { State } from "./state";

export default {
  team: (state: State) => state.team,
  teamInitData: (state: State) => state.teamInitData,
  teams: (state: State) => state.teams,
  teamCount: (state: State) => state.teamCount,
} as GetterTree<State, any>;